import { useTranslation } from 'next-i18next/pages';
import React from 'react';

import { buildInquiryHref } from '@/components/apps/ui/inquiryForm/inquiryCtaSource';

import { SolutionCtaSection } from '../../shared/SolutionCtaSection';

/**
 * ### IndustrialPocCtaSection
 *
 * Places the shared call-to-action section at the end of the Listen AI
 * Industrial page, leading to the PoC inquiry form with the Industrial lead
 * source attached.
 *
 * @returns The rendered call-to-action section element
 * @see {@link SolutionCtaSection} The shared section this configures
 */
export default function IndustrialPocCtaSection() {
  const { t } = useTranslation('common');

  return (
    <SolutionCtaSection
      tone="dark"
      analyticsSectionId="poc_inquiry"
      title={t('Industrial PoC 문의')}
      description={t(
        '양산 라인 품질검사부터 EOL 출하 전 최종 검사, 설비 예지보전까지 적용 가능성을 상담해보세요',
      )}
      actions={[
        {
          href: buildInquiryHref({
            interest: 'poc-terms',
            source: 'industrial-poc',
          }),
          label: t('PoC 문의하기'),
          className:
            'bg-apps-coreGrayWhite text-apps-coreGrayBlack hover:bg-apps-brandGray900 hover:text-apps-coreGrayBlack',
          analyticsContentId: 'industrial_poc_inquiry',
          analyticsContentType: 'poc_cta',
        },
        {
          href: '/about/resources',
          label: t('관련 자료 보기'),
          variant: 'line',
          analyticsContentId: 'industrial_resources',
          analyticsContentType: 'cta',
        },
      ]}
    />
  );
}
